import React, { useMemo } from 'react';
import { useUserData } from '../../store/useUserData';
import { SecurityRoleResponse } from '../../core/API/securityRoles';
import { resolveHomePageVariant } from './utils/homePage';
import ManagerHomePage from './DashBoard';
import EmployeeHomePage from './EmployeeHomePage';

const HomePage = () => {
	const { currentUserRole } = useUserData();

	const variant = useMemo(
		() => resolveHomePageVariant(currentUserRole as SecurityRoleResponse | null),
		[currentUserRole],
	);

	if (variant === 'employee') {
		return <EmployeeHomePage />;
	}

	return <ManagerHomePage />;
};

export default HomePage;
